// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__GZGwl","content":"Consent_content__16bOx","footer":"Consent_footer__MT8_R"};